export function isPointInBounds(bound, point) {
    const ptInSect = (x, a, b) => (x - a) * (x - b) <= 0;

    const { nw, se } = bound;

    const lngs = nw.lng < se.lng
        ? [[nw.lng, se.lng]]
        : [[nw.lng, 180], [-180, se.lng]];

    return ptInSect(point.lat, se.lat, nw.lat) &&
        lngs.some(([lngFrom, lngTo]) => ptInSect(point.lng, lngFrom, lngTo));
}


// WEBPACK FOOTER //
// ./src/services/googleMapsUtility.js